<template>
  <div>
    <el-dialog
      title="编辑批注"
      center
      :visible="true"
      @before-close="onClose"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
    >
      <div>
        <el-input v-model="form.value" rows="15" type="textarea"></el-input>

        <el-button
          style="margin-top: 10px"
          type="primary"
          size="mini"
          plain
          icon="el-icon-close"
          @click="onClose()"
          >取消</el-button
        >
        <el-button
          style="margin-top: 10px; float: right"
          type="primary"
          size="mini"
          plain
          icon="el-icon-check"
          @click="edit()"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditMicrofilmDialog";

export default {
  data() {
    return {
      form: {
        key: "",
        value: "",
      },
    };
  },
  components: {},

  created() {
    let value = this.$dialogutil.getData(DialogName);
    this.form = value;
  },

  methods: {
    async edit() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改批注？`);
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateMicrofilm`,
            {
              key: this.form.key,
              value: this.form.value,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.onCloseWhitParam({ value: this.form.value });
      } catch (error) {
        this.$message.error(error);
      }
    },
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      dialogutil.close(DialogName, param);
    },
  },
};
</script>